export default (theFoodItem, cartItem, isReorder = false) => {
    let itemPrice = 0.00;

    // get the price for the size
    if (theFoodItem.prices) {
        theFoodItem.prices.forEach((thePrice) => {
            if (thePrice.id == cartItem.price_id) {
                itemPrice += parseFloat(thePrice.price);
            }
        });
    }

    // get the price attached to each choice
    if (theFoodItem.choices) {
        theFoodItem.choices.forEach((theChoice) => {
            cartItem.choices.forEach((theItemChoice) => {

                if (theChoice.id == theItemChoice.id) {

                    // we have a match!
                    if (theItemChoice.is_multiple == 0) {

                        // single choice, add the total
                        itemPrice += parseFloat(theItemChoice.item_price);
                    }
                    else {

                        if (isReorder) {
                            theItemChoice.items.forEach((theItemChoiceItem) => {
                                theChoice.items.forEach((theChoiceItem) => {
                                    if (theItemChoiceItem == theChoiceItem.id) {
                                        itemPrice += parseFloat(theChoiceItem.price);
                                    }
                                });
                            });
                        }
                        else {
                            // multiple choices, go through the items and add the prices
                            theItemChoice.items.forEach((theItemChoiceItem) => {
                                theChoice.selections.forEach((theChoiceItem) => {
                                    if (theItemChoiceItem == theChoiceItem.id) {
                                        itemPrice += parseFloat(theChoiceItem.price);
                                    }
                                });
                            });
                        }
                    }
                }
            });
        });
    }

    // add the prices for the modifiers
    cartItem.modifiers.forEach((foodItemModifier) => {
        foodItemModifier.items.forEach((item) => {
            itemPrice += parseFloat(item.price);
        });
    });    
    
    if (theFoodItem.addons) {
        // add the prices for each addon
        theFoodItem.addons.forEach((theAddon) => {
            cartItem.addons.forEach((theItemAddonID) => {
                if (theAddon.id == theItemAddonID) {
                    itemPrice += parseFloat(theAddon.price);
                }
            })
        });
    }

    itemPrice *= cartItem.quantity;
    
    return itemPrice;
}